import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const adminApi = axios.create({
  baseURL: '/content-management-api', // Use relative path instead of environment variable

  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: set the token dynamically
// Note: Using localStorage directly to avoid circular dependency with store
adminApi.interceptors.request.use(
  (config) => {
    // Get token from localStorage (store also uses this as fallback)
    // This avoids circular dependency:
    // contentManagementApi -> store -> content -> NetworkContent -> contentManagementApi
    const token = localStorage.getItem('jwt') || localStorage.getItem('token');

    if (token) {
      // Check if token already has Bearer prefix
      const tokenValue = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      // Set Authorization header directly on the config headers object
      // (avoid spreading AxiosHeaders - it can lose properties in axios 1.x)
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = tokenValue;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data;
    const stepUpRequired =
      status === 403 &&
      (data?.error === 'ADMIN_STEP_UP_REQUIRED' ||
        data?.message?.error === 'ADMIN_STEP_UP_REQUIRED');

    if (stepUpRequired) {
      const currentPath = window.location.pathname;
      if (!currentPath.startsWith('/auth/admin-step-up')) {
        const redirect = `${currentPath}${window.location.search || ''}`;
        window.location.href = `/auth/admin-step-up?redirect=${encodeURIComponent(redirect)}`;
        return Promise.reject(error);
      }
    }

    // Handle 401 errors by redirecting to auth page
    // Using window.location to avoid circular dependency with router
    if (status === 401) {
      const currentPath = window.location.pathname;
      // Don't redirect on auth page, login page, or evaluation questionnaire page
      // (external users access questionnaire without being logged in)
      if (currentPath !== '/auth'
        && currentPath !== '/login'
        && !currentPath.startsWith('/evaluation')
        && !currentPath.startsWith('/auth/admin-step-up')) {
        window.location.href = '/auth';
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);
